import { render, staticRenderFns } from "./group_detail.vue?vue&type=template&id=e42bed8e&scoped=true"
import script from "./group_detail.vue?vue&type=script&lang=js"
export * from "./group_detail.vue?vue&type=script&lang=js"
import style0 from "./group_detail.vue?vue&type=style&index=0&id=e42bed8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e42bed8e",
  null
  
)

export default component.exports